module.exports = __webpack_public_path__ + "static/media/Group 1363.b875b9c0.svg";